import Alpine from "alpinejs";

Alpine.data("priceRangeFilter", (paramName, min, max) => ({
  paramName: paramName,
  min: min,
  max: max,
  isActive: false,
  init() {
    const currentValue = this.getCurrentValue();

    if (!currentValue) {
      return;
    }

    if (currentValue) {
      if (currentValue.min === this.min && currentValue.max === this.max) {
        this.isActive = true;
      }
    }
  },
  getCurrentValue() {
    const urlParams = new URLSearchParams(window.location.search);
    const currentMin = urlParams.get(`${this.paramName}.gte`);
    const currentMax = urlParams.get(`${this.paramName}.lte`);

    if (!currentMin || !currentMax) return null;

    return {
      min: parseFloat(currentMin),
      max: parseFloat(currentMax),
    };
  },
  get urlToAdd() {
    const url = new URL(window.location.href);
    url.searchParams.set(`${this.paramName}.gte`, this.min);
    url.searchParams.set(`${this.paramName}.lte`, this.max);
    return url.toString();
  },
  get urlToRemove() {
    const url = new URL(window.location.href);
    url.searchParams.delete(`${this.paramName}.gte`);
    url.searchParams.delete(`${this.paramName}.lte`);
    return url.toString();
  },
}));
